import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconPrevProps extends SVGProps<any> {}
export class SVGIconPrev extends Component<SVGIconPrevProps> {
  render() {
    const { width = 40, height = 40, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-prev"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          d="M36.6669 40H40V26.4223C39.9969 22.3741 38.4173 18.4925 35.6076 15.6289C32.7979 12.7653 28.9876 11.1536 25.0125 11.1473L16.9413 10.8859V0L1.46385 15.7722C0.52655 16.7271 0 18.0219 0 19.372C0 20.7222 0.52655 22.017 1.46385 22.9718L16.938 38.7441V27.8581L25.0125 28.1195C28.1037 28.1253 31.0665 29.3793 33.2512 31.6064C35.4359 33.8335 36.6642 36.852 36.6669 40ZM25.0008 24.725L13.5982 24.4637V30.5499L3.80872 20.572C3.49628 20.2537 3.32077 19.8221 3.32077 19.372C3.32077 18.922 3.49628 18.4904 3.80872 18.1721L13.6065 8.19416V14.2804L25.0125 14.5418C28.1057 14.5444 31.0715 15.797 33.2587 18.0245C35.4459 20.2519 36.6759 23.2722 36.6785 26.4223V30.409C35.2751 28.6335 33.4985 27.2012 31.4795 26.2175C29.4605 25.2338 27.2506 24.7238 25.0125 24.725H25.0008Z"
          fill="#513389"
        />
      </SVG>
    );
  }
}
